import * as styled from './styles';

export const DotTyping = () => <styled.DotTyping />;
